import { useContext, useState } from "react";
import { ApprovalContext } from "./Approvals";
import css3 from "../css/approval-table.module.css";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import { format, parseISO } from "date-fns";

// Rows arrive already paginated by the server (see DisplayApproval).
const ApprovalTable = (props: any) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);
  const { setShowModal, setModalView, setModalData } =
    useContext(ApprovalContext);

  const pageData: any[] = props?.data ?? [];

  const handleMore = (index: number) => {
    if (index == showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };

  const handleViewDetails = (data: any) => {
    setModalView("view");
    setShowModal(true);
    setModalData(data);
  };

  const handleApproveOrDecline = (data: any) => {
    setModalView("approve");
    setShowModal(true);
    setModalData(data);
  };

  const formatDate = (date: string) => {
    if (!date) return "";

    const parsedDate = parseISO(date);
    const formattedDate = format(parsedDate, "d MMM yyyy");

    return formattedDate;
  };

  return (
    <div className={css3.container}>
      <>
        <div
          style={{ gridTemplateColumns: `0.6fr 0.6fr 0.6fr 1.3fr 0.6fr 0.4fr 0.8fr` }}
        >
          <div>ApplicationDate</div>
          <div>First Name</div>
          <div>Surname Name</div>
          <div>Email Address</div>
          <div>Phone</div>
          <div> Score</div>
          <div>Approval Status</div>
        </div>
        <div>
          {pageData &&
            pageData.length > 0 &&
            pageData.map((eData: any, index: number): any => (
              <div
                key={index}
                style={{
                  gridTemplateColumns: `0.6fr 0.6fr 0.6fr 1.3fr 0.6fr 0.4fr 0.8fr`,
                }}
              >
                <div>{formatDate(eData?.ApplicationDate)}</div>
                <div>{eData.FirstName}</div>
                <div>{eData.LastName}</div>
                <div>{eData.Email || "N/A"}</div>
                <div>{eData.PhoneNumber || "N/A"}</div>
                <div>{eData.TotalScore || "N/A"}</div>
                <div>
                  <div>{eData?.Status === 0 ? "pending" : "Approved"}</div>

                  <span
                    className={`${css3.moreSpan} ${
                      index == showIndex ? `${css3.activeMore}` : ""
                    } `}
                    onClick={() => handleMore(index)}
                  >
                    <MoreIcon />
                    {index == showIndex && showMore ? (
                      <div>
                        <div onClick={() => handleViewDetails(eData)}>
                          View Details
                        </div>

                        <div onClick={() => handleApproveOrDecline(eData)}>
                          Decline | Approve
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
            ))}
        </div>

      </>
    </div>
  );
};

export default ApprovalTable;
